import React from 'react'
import { Table } from '../../components/table/Table'

export const table = (element, props) => (
  <Table { ...props } />
)